import script from "./IFRSCheckerContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./IFRSCheckerContainer.vue?vue&type=script&setup=true&lang=js"

import "./IFRSCheckerContainer.vue?vue&type=style&index=0&id=5127e004&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5127e004"]])

export default __exports__